export const USER_ROLES = {
  ROLE_ADMIN: 'admin',
  ROLE_PARENT: 'parent',
  ROLE_TECAHER: 'teacher',
};
